interface Country {
  code: string; // 'global' | ISO alpha-2 uppercase
  label: string;
  flag: string;
}

/**
 * The country tab bar above the composer.
 *
 * `global` (no flag, brand-tier) sits first; the rest are countries we plan
 * to ship dedicated IG accounts for. As more launch markets land, append
 * to this list — the backend test-users filter + the per-country social
 * connections lookup adapt automatically. Country codes are uppercase
 * ISO 3166-1 alpha-2 so they line up with `social_connections.country`
 * and `user_profiles.country_code`.
 */
const COUNTRIES: Country[] = [
  { code: 'global', label: 'Global', flag: '🌐' },
  { code: 'SE', label: 'Sweden', flag: '🇸🇪' },
  { code: 'DE', label: 'Germany', flag: '🇩🇪' },
  { code: 'FR', label: 'France', flag: '🇫🇷' },
  { code: 'GB', label: 'UK', flag: '🇬🇧' },
  { code: 'IL', label: 'Israel', flag: '🇮🇱' },
];

interface Props {
  value: string; // 'global' | ISO alpha-2
  onChange: (code: string) => void;
}

export function CountryTabs({ value, onChange }: Props) {
  return (
    <nav className="country-tabs" aria-label="Country">
      {COUNTRIES.map((c) => {
        const active = c.code === value;
        return (
          <button
            key={c.code}
            type="button"
            className={
              active ? 'country-tab country-tab-active' : 'country-tab'
            }
            onClick={() => onChange(c.code)}
            aria-current={active ? 'page' : undefined}
          >
            <span className="country-tab-flag" aria-hidden="true">
              {c.flag}
            </span>
            <span className="country-tab-label">{c.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export { COUNTRIES };
